import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';

import { NavigationItem, NavigationService } from '../../../../public-api';

@Component({
  selector: 'lib-vertical-menu-mobile-item',
  standalone: true,
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    MatTooltipModule
  ],
  templateUrl: './vertical-menu-mobile-item.component.html',
  styleUrl: './vertical-menu-mobile-item.component.scss'
})
export class VerticalMenuMobileItemComponent {
  @Input() item!: NavigationItem;
  @Input() isCollapsed = false;
  @Input() level = 0;
  @Input() isHandset = false;

  private navigationService = inject(NavigationService);
  private router = inject(Router);

  onItemClick(item: NavigationItem, event?: Event): void {
    if (item.disabled) return;

    // Stop event propagation to prevent parent clicks
    if (event) {
      event.stopPropagation();
    }

    // If item has children route, navigate directly and expand/collapse
    if (item.children && item.children.length > 0) {
      // On mobile, if already expanded and has route, navigate
      if (this.isHandset && item.expanded && item.route) {
        this.navigationService.navigateTo(item.route);
      }

      // Otherwise, toggle expansion
      item.expanded = !item.expanded;
    }

    // Navigate or execute action for leaf items
    if (item.route) {
      this.navigationService.navigateTo(item.route);
    }

    if (item.action) {
      this.navigationService.executeAction(item.action);
    }

    // Auto-close mobile menu after navigation
    if (this.isHandset) {
      this.navigationService.setCollapse(true);
    }
  }

  isActive(item: NavigationItem): boolean {
    if (!item.route) return false;
    return this.router.url === item.route;
  }
}
